const ICON_CLOSE_X = ({ color = "#000", strokeWidth = 1, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 10"
    fill="none"
    {...props}
  >
    <path
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M2.414.25h5.172A2.16 2.16 0 0 1 9.75 2.414v5.172A2.16 2.16 0 0 1 7.586 9.75H2.414A2.16 2.16 0 0 1 .25 7.586V2.414A2.16 2.16 0 0 1 2.414.25z"
      style={{
        paintOrder: "markers fill stroke",
      }}
    />
    <path
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeWidth={0.5}
      d="m7.715 2.29-5.42 5.42M2.296 2.29l5.418 5.42"
      style={{
        paintOrder: "markers fill stroke",
      }}
    />
  </svg>
);

export default ICON_CLOSE_X;
